import { Grid, styled } from "@mui/material";

export const GridContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0, 2),
}));
